import { useSessionExpired } from '../lib/session';

// Shown when the Cloudflare Access sign-in has expired (see lib/session.ts).
// Signing in happens in a new tab so this one keeps whatever was typed; the
// sign-in cookie is shared, so saving again here then goes through and the
// banner clears itself.
export function SessionBanner() {
  const expired = useSessionExpired();
  if (!expired) return null;
  return (
    <div className="session-banner" role="alert">
      <p>
        <strong>Your sign-in has expired, so that didn’t save.</strong> Sign in again in a new tab,
        then come back here and save again. Everything you’ve typed is still here.
      </p>
      <button className="primary" type="button" onClick={() => window.open('/', '_blank')}>
        Sign in again
      </button>
    </div>
  );
}
